"use client";
import { verifyDodoPayment } from "api/subscription/verifyDodoPayment";
import {
  useAppSelector,
  useSaveStateToLocalStorageOnChange,
  useSetInitialStore,
} from "lib/redux/hooks";
import { selectDodoRedirectUrl } from "lib/redux/uiSlice";
import { useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";

const VerifyDodoPayment = () => {
  useSetInitialStore();
  useSaveStateToLocalStorageOnChange();
  const redirectUrl = useAppSelector(selectDodoRedirectUrl);
  const searchParams = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [hasAttemptedVerification, setHasAttemptedVerification] =
    useState(false);

  const handleVerifyDodoPayment = async () => {
    console.debug("Redirecting to...", redirectUrl);
    try {
      const paymentId = searchParams.get("payment_id");
      const status = searchParams.get("status");

      if (!paymentId) {
        throw new Error("Payment ID not found.");
      }

      const isVerified = await verifyDodoPayment(paymentId!);

      if (isVerified && status === "succeeded") {
        console.debug("Verification Successfull");
        window.location.href = redirectUrl;
      } else {
        throw new Error("Payment verification failed.");
      }
    } catch (error) {
      console.error("Error in handleVerifyDodoPayment", error);
      setError((error as Error).message || "Something went wrong.");
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log("redirectUrl", redirectUrl);
    if (!redirectUrl || hasAttemptedVerification) {
      return;
    }

    setHasAttemptedVerification(true);
    handleVerifyDodoPayment();
  }, [redirectUrl, hasAttemptedVerification]);
  return (
    <div className="flex min-h-screen items-center justify-center bg-white">
      <div className="flex w-full max-w-sm flex-col items-center rounded-lg bg-white p-8 text-center shadow-lg">
        {loading ? (
          <>
            <div className="h-16 w-16 animate-spin rounded-full border-t-4 border-solid border-gray-300 border-t-blue-500"></div>
            <h2 className="mt-6 text-lg font-medium text-gray-700">
              Verifying your payment...
            </h2>
            <p className="mt-2 text-sm text-gray-500">
              Please wait while we process your payment. Do not refresh the
              page.
            </p>
          </>
        ) : (
          <>
            <div className="text-red-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-16 w-16"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M13 16h-1v-4h-1m1-4h.01M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9z"
                />
              </svg>
            </div>
            <h2 className="mt-4 text-lg font-medium text-gray-700">
              Payment Verification Failed
            </h2>
            <p className="mt-2 text-sm text-gray-500">{error}</p>
            <button
              className="mt-6 rounded bg-blue-500 px-4 py-2 text-white shadow transition hover:bg-blue-600"
              onClick={() => window.location.reload()}
            >
              Retry
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyDodoPayment;
